/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_GROUPS (state, groups) {
    state.groups = groups
  },
  REMOVE_GROUPS (state, itemId) {
    const pageIndex = state.groups.findIndex((u) => u.GroupId === itemId)
    state.groups.splice(pageIndex, 1)
  }
}
